<wp-card-page brand="Werfy" logoUrl="assets/images/werfy-logo-pink.svg" platform="Recruitment">
  <router-outlet></router-outlet>
  <!--  TODO : Create disclaimer, privacy etc. component /links-->
  <!--  TODO : Contact us / feedback link-->
  <p slot="footer">Werfy {{ year }} &copy;</p>
</wp-card-page>
